//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GenericModal } from "@Shared/components/modals";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SwapApplicationConfirmationModal",
  components: {
    GenericModal,
    SimpleButton
  },
  props: {
    selectedApplicantName: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleConfirmClick() {
      this.$emit("submit");
    }
  }
});